const DEFAULT_LOCAL_API_GATEWAY = 'https://localhost:44318';

let warnedRemoteGatewayOverride = false;

const normalizeUrl = (value?: string): string =>
  (value || '').trim().replace(/\/+$/, '');

const stripApiSuffix = (value?: string): string =>
  normalizeUrl(value).replace(/\/api$/i, '');

const isLocalHostname = (hostname: string): boolean =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '0.0.0.0' ||
  hostname.endsWith('.local');

const isLocalUrl = (value: string): boolean => {
  try {
    return isLocalHostname(new URL(value).hostname);
  } catch {
    return /localhost|127\.0\.0\.1|0\.0\.0\.0/i.test(value);
  }
};

const isLocalRuntime = (): boolean => {
  if (import.meta.env.DEV) {
    return true;
  }

  try {
    return isLocalHostname(window.location.hostname);
  } catch {
    return false;
  }
};

export const resolveRuntimeApiGatewayUrl = (): string => {
  const configured = normalizeUrl(
    import.meta.env.VITE_API_GATEWAY_URL ||
      stripApiSuffix(import.meta.env.VITE_API_BASE_URL) ||
      DEFAULT_LOCAL_API_GATEWAY,
  );

  if (isLocalRuntime() && !isLocalUrl(configured)) {
    if (!warnedRemoteGatewayOverride) {
      console.warn(
        `[API] App is running locally but API gateway is "${configured}". ` +
          `Using local gateway "${DEFAULT_LOCAL_API_GATEWAY}" instead.`,
      );
      warnedRemoteGatewayOverride = true;
    }
    return DEFAULT_LOCAL_API_GATEWAY;
  }

  return configured;
};
